export const TOGGLE_SCHEDULE_TYPE = "TOGGLE_SCHEDULE_TYPE";
export const TOGGLE_SCHEDULE_INTERVAL = "TOGGLE_SCHEDULE_INTERVAL";
export const TOGGLE_SCHEDULE_START_TIME = "TOGGLE_SCHEDULE_START_TIME";
export const TOGGLE_SCHEDULE_DAYS = "TOGGLE_SCHEDULE_DAYS";
export const TOGGLE_SCHEDULE_MONTHS = "TOGGLE_SCHEDULE_MONTHS";
export const TOGGLE_SCHEDULE_MONTH_DAYS = "TOGGLE_SCHEDULE_MONTH_DAYS";
export const TOGGLE_SCHEDULE_RETENTION = "TOGGLE_SCHEDULE_RETENTION";
export const TOGGLE_SCHEDULE_DEVICE = "TOGGLE_SCHEDULE_DEVICE";
export const TOGGLE_SCHEDULE_LOGIN_DETAILS = "TOGGLE_SCHEDULE_LOGIN_DETAILS";
export const TOGGLE_NOTIFICATION_ENABLE = "TOGGLE_NOTIFICATION_ENABLE";
export const CHANGE_NOTIFICATION_CURRENT_EMAIL =
  "CHANGE_NOTIFICATION_CURRENT_EMAIL";
export const ADD_NOTIFICATION_EMAIL = "ADD_NOTIFICATION_EMAIL";
export const ADD_MULTIPLE_NOTIFICATION_EMAIL =
  "ADD_MULTIPLE_NOTIFICATION_EMAIL";
export const TOGGLE_NOTIFICATION_REMOVE_EMAIL =
  "TOGGLE_NOTIFICATION_REMOVE_EMAIL";
export const CHANGE_NOTIFICATION_SMTP_SETTING =
  "CHANGE_NOTIFICATION_SMTP_SETTING";
export const TOGGLE_NOTIFICATION_OPERATION_STATUS =
  "TOGGLE_NOTIFICATION_OPERATION_STATUS";
export const TOGGLE_NOTIFY_ON_DESKTOP = "TOGGLE_NOTIFY_ON_DESKTOP";
export const TOGGLE_SOURCE_TYPE = "TOGGLE_SOURCE_TYPE";
export const TOGGLE_SOURCE_DEVICE = "TOGGLE_SOURCE_DEVICE";
export const TOGGLE_SOURCE_VOLUME = "TOGGLE_SOURCE_VOLUME";
export const TOGGLE_ENCRYPTION_TYPE = "TOGGLE_ENCRYPTION_TYPE";
export const CHANGE_ENCRYPTION_KEY = "CHANGE_ENCRYPTION_KEY";
export const FETCH_BACKUP_SETTINGS_START = "FETCH_BACKUP_SETTINGS_START";
export const FETCH_BACKUP_SETTINGS_SUCCESS = "FETCH_BACKUP_SETTINGS_SUCCESS";
export const FETCH_BACKUP_SETTINGS_FAILURE = "FETCH_BACKUP_SETTINGS_FAILURE";
export const SAVE_BACKUP_SETTINGS_START = "SAVE_BACKUP_SETTINGS_START";
export const SAVE_BACKUP_SETTINGS_SUCCESS = "SAVE_BACKUP_SETTINGS_SUCCESS";
export const UPDATE_BACKUP_SETTINGS_START = "UPDATE_BACKUP_SETTINGS_START";
export const BACKUP_SETTINGS_CHANGED = "BACKUP_SETTINGS_CHANGED";
export const NOTIFICATION_SLIDING_POPUP = "NOTIFICATION_SLIDING_POPUP";
export const REMOVE_SLIDING_POPUP_NOTIFICATION =
  "REMOVE_SLIDING_POPUP_NOTIFICATION";
export const CANCEL_EDIT_BACKUP_SETTING = "CANCEL_EDIT_BACKUP_SETTING";
export const INITIATE_FULL_BACKUP = "INITIATE_FULL_BACKUP";
export const CLOSE_BACKUP_SETTINGS = "CLOSE_BACKUP_SETTINGS";
export const REMOVE_MACHINE_START = "REMOVE_MACHINE_START";
export const CLOSE_REFRESH = "CLOSE_REFRESH";
export const CLEAR_BACKUP_SETTINGS = "CLEAR_BACKUP_SETTINGS";
export const TOGGLE_CLEANUP_SCHEDULE_COUNT = "TOGGLE_CLEANUP_SCHEDULE_COUNT";
export const TOGGLE_CLEANUP_MONTHS = "TOGGLE_CLEANUP_MONTHS";
export const TOGGLE_CLEANUP_MONTHS_CHECK = "TOGGLE_CLEANUP_MONTHS_CHECK";
export const TOGGLE_PERFORMANCE_SPEED_LIMIT = "TOGGLE_PERFORMANCE_SPEED_LIMIT";
export const TOGGLE_PERFORMANCE_PRIORITY = "TOGGLE_PERFORMANCE_PRIORITY";
export const TOGGLE_PERFORMANCE_SPEED = "TOGGLE_PERFORMANCE_SPEED";
export const TOGGLE_SKIP_DISK_ERR = "TOGGLE_SKIP_DISK_ERR";
export const PRE_BACKUP_SETTINGS_CHANGED = "PRE_BACKUP_SETTINGS_CHANGED";
export const ACCOUNT_SETTINGS_CHANGED = "ACCOUNT_SETTINGS_CHANGED";
export const TOGGLE_CUT_OFF_TIME = "TOGGLE_CUT_OFF_TIME";
export const TOGGLE_CUT_OFF_ENABLE = "TOGGLE_CUT_OFF_ENABLE";
export const ADD_CLIENTS_TO_PLAN_START = "ADD_CLIENTS_TO_PLAN_START";
export const REMOVE_MACHINE_FROM_HEADER_SUCCESS =
  "REMOVE_MACHINE_FROM_HEADER_SUCCESS";
export const REMOVE_MACHINE_FROM_HEADER_FAILURE =
  "REMOVE_MACHINE_FROM_HEADER_FAILURE";
export const RESET_REMOVE_MACHINES_LIST = "RESET_REMOVE_MACHINES_LIST";
